/* Variant-first Shopify-hosted Artisan media. */
(function () {
  function extension(value) {
    var match = String(value || '').match(/\.([a-z0-9]+)(?:[?#]|$)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function isPdf(media) {
    return media && (media.mediaType === 'generic_file' || extension(media.url) === 'pdf');
  }

  function createLink(url, text, download) {
    var link = document.createElement('a');
    link.href = url;
    link.textContent = text;
    link.className = 'artisan-media-proof__action';
    if (download) link.setAttribute('download', '');
    else {
      link.target = '_blank';
      link.rel = 'noopener';
    }
    return link;
  }

  function setResponsiveSource(image, value) {
    // Shopify-hosted still images retain a full-size candidate for desktop,
    // but small screens should not download the 1600px documentation image.
    const url = new URL(value, location.href);
    const shopifyImage = url.hostname === 'cdn.shopify.com' ||
      (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'));
    if (shopifyImage && !/\.(gif|pdf)(?:[?#]|$)/i.test(value)) {
      image.sizes = '(min-width: 1024px) 40vw, calc(100vw - 64px)';
      image.srcset = [320,480,640,960,1280,1600].map(width => {
        const candidate = new URL(url); candidate.searchParams.set('width', width);
        return candidate.href + ' ' + width + 'w';
      }).join(',');
    } else { image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
    image.src = value;
  }

  function createImage(url, alt) {
    var frame = document.createElement('div');
    frame.className = 'artisan-media-proof__frame';
    var image = document.createElement('img');
    setResponsiveSource(image, url);
    image.alt = alt;
    image.loading = 'lazy';
    image.fetchPriority = 'low';
    image.className = 'artisan-media-proof__image';
    image.width = 1200;
    image.height = 900;
    frame.appendChild(image);
    return frame;
  }

  function createPdfCard(url, title) {
    var card = document.createElement('div');
    card.className = 'artisan-doc-card';

    var info = document.createElement('div');
    info.className = 'artisan-doc-card__info';

    var icon = document.createElement('div');
    icon.className = 'artisan-doc-card__icon';
    icon.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>';

    var text = document.createElement('div');
    text.className = 'artisan-doc-card__text';
    var heading = document.createElement('span');
    heading.className = 'artisan-doc-card__title';
    heading.textContent = title;
    var sub = document.createElement('span');
    sub.className = 'artisan-doc-card__sub';
    sub.textContent = 'PDF Document • Official Instructions';
    text.appendChild(heading);
    text.appendChild(sub);

    info.appendChild(icon);
    info.appendChild(text);

    var link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener';
    link.className = 'artisan-doc-card__btn';
    link.innerHTML = '<span>Open / Download PDF</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

    card.appendChild(info);
    card.appendChild(link);
    return card;
  }

  // Reveal a loaded card. Chrome's scroll anchoring keeps the view still when a card appears above the
  // viewport; restoring the old scroll offset afterwards (as this used to) undid that and moved the page.
  function reveal(mutator) {
    mutator();
  }

  // Start once the page has loaded and the main thread is idle, or earlier if the shopper scrolls close.
  // Starting only when the shopper reached the cards revealed them while they were on screen, which moved
  // the recommendations below (CLS 0.18 on a phone, Oct 2026). After load, the shopper is usually still above
  // them, and waiting for the load event keeps these below-the-fold images from competing with the main photo.
  // The cards start hidden (a lazy image in a hidden card never loads), so watch the closest ancestor in layout.
  function whenNear(element, callback) {
    if (!('IntersectionObserver' in window)) return callback();
    var done = false;
    var target = element;
    for (var hidden = target.closest('[hidden]'); hidden && hidden.parentElement; hidden = target.closest('[hidden]')) {
      target = hidden.parentElement;
    }
    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) run();
    }, { rootMargin: '600px 0px' });
    function run() {
      if (done) return;
      done = true;
      observer.disconnect();
      callback();
    }
    function whenIdle() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2000 });
      else setTimeout(run, 200);
    }
    observer.observe(target);
    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
  }

  function initLifestyle(wrap) {
    if (!wrap || wrap.dataset.artisanLifestyleInitialized === 'true') return;
    wrap.dataset.artisanLifestyleInitialized = 'true';

    var sectionId = wrap.dataset.sectionId;
    var dataElement = document.getElementById('artisan-media-data-' + sectionId);
    var image = wrap.querySelector('[data-artisan-lifestyle-image]');
    var productBlock = wrap.closest('.product__block--room_visualization');
    if (!dataElement || !image) return;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('[ARTISAN LIFESTYLE DATA]', error);
      return;
    }

    var currentVariantId = data.selectedVariantId;
    var sequence = 0;
    if (productBlock) productBlock.hidden = true;

    function resolveLifestyle() {
      var record = data.variants[String(currentVariantId)];
      if (!record) return null;
      if (record.lifestyle && record.lifestyle.url) return record.lifestyle;
      return null;
    }

    function update() {
      var request = ++sequence;
      var media = resolveLifestyle();
      if (!media || !media.url) {
        wrap.hidden = true;
        image.removeAttribute('src');
        if (productBlock) productBlock.hidden = true;
        return;
      }

      image.onload = function () {
        if (request !== sequence) return;
        reveal(function () {
          wrap.hidden = false;
          if (productBlock) productBlock.hidden = false;
        });
      };
      image.onerror = function () {
        if (request !== sequence) return;
        wrap.hidden = true;
        image.removeAttribute('src');
        if (productBlock) productBlock.hidden = true;
      };
      // A lazy image inside a hidden optional card is never eligible to load,
      // which leaves the card permanently hidden. The card is near the viewport
      // (whenNear), so allow this one low-priority request to start.
      image.loading = 'eager';
      setResponsiveSource(image, media.url);
    }

    var isNear = false;
    document.addEventListener('variant:change', function (event) {
      if (!event.detail || !event.detail.variant) return;
      currentVariantId = event.detail.variant.id;
      if (isNear) update();
    });

    whenNear(wrap, function () {
      isNear = true;
      update();
    });
  }

  function initArtisanMedia(root) {
    if (!root || root.dataset.artisanMediaInitialized === 'true') return;
    root.dataset.artisanMediaInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var dataElement = document.getElementById('artisan-media-data-' + sectionId);
    if (!dataElement) return;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('[ARTISAN MEDIA DATA]', error);
      return;
    }

    var productBlock = root.closest('.product__block--artisan_dimensions');
    var sectionScope = root.closest('[id^="shopify-section-"]') || document;
    var instanceId = root.dataset.artisanInstance;
    var sizeGuideWrap = root.querySelector('[data-artisan-size-guide]');
    var sizeGuideImage = root.querySelector('[data-artisan-size-guide-image]');
    var spinWrap = root.querySelector('[data-artisan-spin]');
    var spinImage = root.querySelector('[data-artisan-spin-image]');
    var humanScaleWrap = root.querySelector('[data-artisan-human-scale]');
    var humanScaleImage = root.querySelector('[data-artisan-human-scale-image]');
    var assemblyWrap = document.getElementById('assembly-wrap-' + instanceId) || root.querySelector('[data-artisan-assembly]') ||
      sectionScope.querySelector('[data-artisan-assembly]');
    var assemblyViewer = assemblyWrap && assemblyWrap.querySelector('[data-artisan-assembly-viewer]');
    var assemblyActions = assemblyWrap && assemblyWrap.querySelector('[data-artisan-assembly-actions]');
    var dimensionsWrap = document.getElementById('dims-wrap-' + instanceId) || root.querySelector('[data-artisan-dimensions]') ||
      sectionScope.querySelector('[data-artisan-dimensions]');
    var dimensionsViewer = dimensionsWrap && dimensionsWrap.querySelector('[data-artisan-dimensions-viewer]');
    var dimensionsActions = dimensionsWrap && dimensionsWrap.querySelector('[data-artisan-dimensions-actions]');
    var currentVariantId = data.selectedVariantId;
    var updateSequence = 0;
    var spinIsNear = !('IntersectionObserver' in window);
    var guidesAreNear = false;
    var resolved = {
      spin: null,
      sizeGuide: null,
      humanScale: null,
      assembly: null,
      dimensions: null
    };

    if (productBlock) productBlock.hidden = true;

    function record() {
      return data.variants[String(currentVariantId)] || null;
    }

    function resolveMedia(kind) {
      var variant = record();
      if (!variant) return null;
      if (variant[kind] && variant[kind].url) return variant[kind];
      return null;
    }

    function revealParent() {
      if (productBlock) productBlock.hidden = false;
    }

    function renderDocument(viewer, actions, media, title) {
      viewer.replaceChildren();
      actions.replaceChildren();
      if (!media || !media.url) return;

      if (isPdf(media)) {
        viewer.appendChild(createPdfCard(media.url, title));
      } else {
        viewer.appendChild(createImage(media.url, title));
        actions.appendChild(createLink(media.url, 'Download image', true));
      }
    }

    function loadSizeGuide(sequence) {
      var media = resolved.sizeGuide;
      if (!sizeGuideWrap || !sizeGuideImage || !media || !media.url) return;

      sizeGuideImage.onload = function () {
        if (sequence !== updateSequence) return;
        reveal(function () {
          sizeGuideImage.width = sizeGuideImage.naturalWidth || 1200;
          sizeGuideImage.height = sizeGuideImage.naturalHeight || 800;
          sizeGuideWrap.hidden = false;
          revealParent();
        });
      };
      sizeGuideImage.onerror = function () {
        if (sequence !== updateSequence) return;
        sizeGuideWrap.hidden = true;
        sizeGuideImage.removeAttribute('src');
      };
      sizeGuideImage.loading = 'eager';
      setResponsiveSource(sizeGuideImage, media.url);
    }

    async function loadSpin(sequence) {
      if (!spinIsNear || !spinWrap || !spinImage) return;
      var media = resolved.spin || await resolveMedia('spin');
      if (sequence !== updateSequence || !media || !media.url) return;
      resolved.spin = media;

      spinImage.onload = function () {
        if (sequence !== updateSequence) return;
        reveal(function () {
          spinImage.width = spinImage.naturalWidth || 800;
          spinImage.height = spinImage.naturalHeight || 800;
          spinWrap.hidden = false;
          revealParent();
        });
      };
      spinImage.onerror = function () {
        if (sequence !== updateSequence) return;
        spinWrap.hidden = true;
        spinImage.removeAttribute('src');
      };
      // loadSpin is already IntersectionObserver-gated; eager only breaks the
      // hidden-card/lazy-image deadlock once the card is near the viewport.
      spinImage.loading = 'eager';
      spinImage.src = media.url;
    }

    function loadHumanScale(sequence) {
      var media = resolved.humanScale;
      if (!humanScaleWrap || !humanScaleImage || !media || !media.url) return;

      humanScaleImage.onload = function () {
        if (sequence !== updateSequence) return;
        reveal(function () {
          humanScaleImage.width = humanScaleImage.naturalWidth || 1200;
          humanScaleImage.height = humanScaleImage.naturalHeight || 1400;
          humanScaleWrap.hidden = false;
          revealParent();
        });
      };
      humanScaleImage.onerror = function () {
        if (sequence !== updateSequence) return;
        humanScaleWrap.hidden = true;
        humanScaleImage.removeAttribute('src');
      };
      humanScaleImage.loading = 'eager';
      setResponsiveSource(humanScaleImage, media.url);
    }

    async function update() {
      var sequence = ++updateSequence;
      resolved = {
        spin: null,
        sizeGuide: null,
        humanScale: null,
        assembly: null,
        dimensions: null
      };
      if (sizeGuideWrap) sizeGuideWrap.hidden = true;
      if (spinWrap) spinWrap.hidden = true;
      if (humanScaleWrap) humanScaleWrap.hidden = true;
      if (assemblyWrap) assemblyWrap.hidden = true;
      if (dimensionsWrap) dimensionsWrap.hidden = true;

      var mediaResults = await Promise.all([
        resolveMedia('assembly'),
        resolveMedia('dimensions'),
        resolveMedia('sizeGuide'),
        resolveMedia('humanScale')
      ]);
      if (sequence !== updateSequence) return;

      resolved.assembly = mediaResults[0];
      resolved.dimensions = mediaResults[1];
      resolved.sizeGuide = mediaResults[2];
      resolved.humanScale = mediaResults[3];
      if (assemblyWrap && resolved.assembly) {
        assemblyWrap.hidden = false;
        revealParent();
      }
      if (dimensionsWrap && resolved.dimensions) {
        dimensionsWrap.hidden = false;
        revealParent();
      }
      if (guidesAreNear) {
        loadSizeGuide(sequence);
        loadHumanScale(sequence);
      }
      loadSpin(sequence);
    }

    whenNear(root, function () {
      guidesAreNear = true;
      loadSizeGuide(updateSequence);
      loadHumanScale(updateSequence);
    });

    if (spinWrap && !spinIsNear) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        spinIsNear = true;
        observer.disconnect();
        loadSpin(updateSequence);
      }, { rootMargin: '1200px 0px' });
      observer.observe(root.closest('[data-kp-media-grid]') || spinWrap);
    }

    if (assemblyWrap) {
      assemblyWrap.addEventListener('toggle', function () {
        if (!assemblyWrap.open || assemblyWrap.dataset.renderedVariant === String(currentVariantId)) return;
        renderDocument(assemblyViewer, assemblyActions, resolved.assembly, 'Assembly instructions');
        assemblyWrap.dataset.renderedVariant = String(currentVariantId);
      });
    }

    if (dimensionsWrap) {
      dimensionsWrap.addEventListener('toggle', function () {
        if (!dimensionsWrap.open || dimensionsWrap.dataset.renderedVariant === String(currentVariantId)) return;
        renderDocument(dimensionsViewer, dimensionsActions, resolved.dimensions, 'Dimensions diagram');
        dimensionsWrap.dataset.renderedVariant = String(currentVariantId);
      });
    }

    document.addEventListener('variant:change', function (event) {
      if (!event.detail || !event.detail.variant) return;
      currentVariantId = event.detail.variant.id;
      update();
    });

    update();
  }

  function initMediaGrid(grid) {
    if (!grid || grid.dataset.artisanGridInitialized === 'true') return;
    grid.dataset.artisanGridInitialized = 'true';

    // An absent media record should not reserve a section gap. Keep the grid in
    // layout: pending images and variants with media still need lazy observation.
    var extra = grid.closest('.kp-pdp-extra');
    var section = grid.closest('.shopify-section');
    var dataElement = section && section.querySelector('[data-artisan-media]');
    if (extra && dataElement) {
      try {
        var data = JSON.parse(dataElement.textContent);
        function syncAvailability(variantId) {
          var record = data.variants[String(variantId)];
          if (!record) return;
          var available = ['lifestyle', 'sizeGuide', 'spin', 'humanScale'].some(function (key) {
            return record[key] && record[key].url;
          });
          if (available) extra.style.removeProperty('--kp-art-media-padding');
          else extra.style.setProperty('--kp-art-media-padding', '0px');
          extra.dataset.kpMediaAvailable = String(available);
        }
        syncAvailability(data.selectedVariantId);
        document.addEventListener('variant:change', function (event) {
          if (event.detail && event.detail.variant) syncAvailability(event.detail.variant.id);
        });
      } catch (error) {
        // Malformed data keeps the default spacing; the media initializers report it.
      }
    }

    function sync() {
      var cards = grid.querySelectorAll('.artisan-lifestyle-block, .artisan-media-proof');
      var count = Array.prototype.filter.call(cards, function (card) { return !card.hidden; }).length;
      var columns = count === 3 ? 3 : 2;
      grid.style.setProperty('--kp-media-cols', String(columns));
      grid.dataset.kpMediaCount = String(count);
    }

    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(grid, {
        attributes: true,
        subtree: true,
        attributeFilter: ['hidden']
      });
    }
  }

  // Tap to enlarge (12 Oct 2026). Clarity showed iPhone shoppers tapping the lifestyle and
  // "See it beside a person" photos and getting nothing (dead clicks), so every Artisan media photo
  // opens full size in a dialog; a tap, the close button or Escape closes it.
  var ZOOM_SELECTOR = '.artisan-media-proof__image, [data-artisan-lifestyle-image]';
  var zoomDialog = null;

  function largeSource(image) {
    var src = image.currentSrc || image.src || '';
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$11800') : src;
  }

  function openZoom(image) {
    var src = largeSource(image);
    if (!src) return;
    if (!zoomDialog) {
      zoomDialog = document.createElement('dialog');
      zoomDialog.className = 'kp-media-zoom';
      zoomDialog.setAttribute('aria-label', 'Enlarged photo');
      zoomDialog.innerHTML = '<button type="button" class="kp-media-zoom__close" aria-label="Close">&times;</button><img class="kp-media-zoom__img" alt="">';
      zoomDialog.addEventListener('click', function () { zoomDialog.close(); });
      document.body.appendChild(zoomDialog);
    }
    var big = zoomDialog.querySelector('.kp-media-zoom__img');
    big.src = src;
    big.alt = image.alt || '';
    if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
    else window.open(src, '_blank', 'noopener');
  }

  function prepareZoom(scope) {
    (scope || document).querySelectorAll(ZOOM_SELECTOR).forEach(function (image) {
      if (image.dataset.kpZoom) return;
      image.dataset.kpZoom = '1';
      image.setAttribute('role', 'button');
      image.setAttribute('tabindex', '0');
      image.setAttribute('aria-label', 'Enlarge photo' + (image.alt ? ': ' + image.alt : ''));
    });
  }

  document.addEventListener('click', function (event) {
    var image = event.target.closest && event.target.closest(ZOOM_SELECTOR);
    if (image) openZoom(image);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var image = event.target.closest && event.target.closest(ZOOM_SELECTOR);
    if (!image) return;
    event.preventDefault();
    openZoom(image);
  });

  function initAll(scope) {
    var target = scope || document;
    prepareZoom(target);
    target.querySelectorAll('[data-artisan-lifestyle]').forEach(initLifestyle);
    target.querySelectorAll('[data-artisan-guides]').forEach(initArtisanMedia);
    target.querySelectorAll('[data-kp-media-grid]').forEach(initMediaGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
